import { createSelector } from 'reselect';

import { createSubUrl, getHeader, getSecondaryInfoText } from './utils';

export const getSpotlightResults = ({ spotlight }) => spotlight.list.data;

export const getResultsCnt = ({ spotlight }) => spotlight.list.count;

export const getIsLoaded = ({ spotlight }) => spotlight.list.isLoaded;

export const getIsSpotlightLoading = ({ spotlight }) =>
  spotlight.list.isLoading;

export const getNormalizedResults = createSelector(
  getSpotlightResults,
  getResultsCnt,
  (data, count) => {
    let normalizedResults = [];

    if (!count) {
      return normalizedResults;
    }

    // normalize search results in order to have a structure as described here
    // https://github.com/reactjs/react-autocomplete/blob/master/lib/utils.js
    Object.keys(data).forEach(resourceName => {
      const resource = data[resourceName];

      if (resource.count) {
        normalizedResults = normalizedResults.concat([
          getHeader(resourceName, resource.count),
          ...resource.results.map(result => {
            const subUrl = createSubUrl(resourceName, result);

            if (resourceName === 'matching_pattern_elements') {
              return {
                id: result.id,
                subUrl,
                name: `${result.rule.name}.${result.entity.name}`,
                nameIsHighlightable: true,
              };
            }

            if (resourceName === 'rules') {
              return {
                ...result,
                subUrl,
                nameIsHighlightable: true,
              };
            }

            if (resourceName === 'dictionary_columns') {
              return {
                id: result.id,
                subUrl,
                name: `${result.dictionary.name}.${result.name}`,
                nameIsHighlightable: true,
              };
            }

            if (resourceName === 'entity_features') {
              return {
                id: result.id,
                subUrl,
                name: `${result.entity_name}.${result.name}`,
                nameIsHighlightable: true,
              };
            }

            if (resourceName === 'constraint_sets') {
              return {
                id: result.id,
                subUrl,
                name: `${result.intent.name}.${result.name}`,
                nameIsHighlightable: false,
                secondaryInfoText: getSecondaryInfoText(resourceName, result),
              };
            }
            if (resourceName === 'dictionaries') {
              return {
                ...result,
                subUrl,
                nameIsHighlightable: true,
                secondaryInfoText: getSecondaryInfoText(resourceName, result),
              };
            }

            return {
              ...result,
              subUrl,
              nameIsHighlightable: true,
            };
          }),
        ]);
      }
    });

    return normalizedResults;
  },
);
